export default "__VITE_ASSET__d9805024__"